module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "category-content order-content"
  }, [_c('div', {
    staticClass: "main-width"
  }, [_c('div', {
    staticClass: "manage-center-content"
  }, [_c('div', {
    staticClass: "manage-slide"
  }, [_c('el-col', [_c('el-menu', {
    staticClass: "el-menu-vertical-demo",
    attrs: {
      "default-active": "1-1",
      "default-openeds": _vm.defaultOpen
    },
    on: {
      "select": _vm.handleSelect
    }
  }, [_c('el-submenu', {
    staticClass: "persion_center",
    attrs: {
      "index": "1"
    }
  }, [_c('template', {
    slot: "title"
  }, [_c('i', {
    staticClass: "default-center-icon"
  }), _vm._v("个人中心\n              ")]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "1-1"
    }
  }, [_c('template', {
    slot: "title"
  }, [_vm._v("个人信息")])], 2), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "1-2"
    }
  }, [_c('template', {
    slot: "title"
  }, [_vm._v("特别关注区域设置")])], 2), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "1-3"
    }
  }, [_c('template', {
    slot: "title"
  }, [_vm._v("个性商城设置")])], 2)], 2)], 1)], 1)], 1), _vm._v(" "), (_vm.selectPage == 1) ? _c('div', [_c('div', {
    staticClass: "manage-info"
  }, [_c('img', {
    attrs: {
      "src": _vm.imgAddress + _vm.info.logoPath
    },
    on: {
      "error": function($event) {
        return _vm.error(4)
      }
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.info.platformName))]), _vm._v(" "), _c('span', {
    staticClass: "update-password-style",
    class: {
      'display-none': !_vm.isModify
    },
    on: {
      "click": _vm.showModifyPw
    }
  }, [_vm._v("修改密码")])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isModify),
      expression: "isModify"
    }]
  }, [_c('div', {
    staticClass: "manage-config-info"
  }, [_c('div', {
    staticClass: "manage-config-info-title"
  }, [_vm._v("时间配置信息")]), _vm._v(" "), _c('div', {
    staticClass: "manage-config-info-content"
  }, [_c('div', [_vm._v("已收货天数：" + _vm._s(_vm.info.toReceiveDays) + "天")]), _vm._v(" "), _c('div', [_vm._v("已完成天数：" + _vm._s(_vm.info.toSuccessDays) + "天")])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isAddressModify),
      expression: "isAddressModify"
    }],
    staticClass: "manage-config-info margin-bottom-15"
  }, [_c('div', {
    staticClass: "manage-config-info-title"
  }, [_vm._v("收票地址信息")]), _vm._v(" "), _c('div', {
    staticClass: "manage-config-info-content"
  }, [_c('div', [_vm._v("\n                地址：\n                "), _c('span', [_vm._v(_vm._s(_vm.info.address))])]), _vm._v(" "), _c('div', [_vm._v("\n                电话：\n                "), _c('span', [_vm._v(_vm._s(_vm.info.tel))])]), _vm._v(" "), _c('span', {
    staticClass: "manage-modify-btn font-color-orange",
    on: {
      "click": _vm.showUpdateAddress
    }
  }, [_vm._v("修改")])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isAddressModify),
      expression: "!isAddressModify"
    }],
    staticClass: "manage-config-info margin-bottom-15"
  }, [_c('div', {
    staticClass: "manage-config-info-title"
  }, [_vm._v("收票地址信息")]), _vm._v(" "), _c('div', {
    staticClass: "manage-config-info-content"
  }, [_c('div', [_vm._v("\n                地址：\n                "), _c('span', {
    staticClass: "manage-config-info-input"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.userAddress),
      expression: "userAddress"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.userAddress)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.userAddress = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', [_vm._v("\n                电话：\n                "), _c('span', {
    staticClass: "manage-config-info-input"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.userMobil),
      expression: "userMobil"
    }],
    attrs: {
      "type": "tel"
    },
    domProps: {
      "value": (_vm.userMobil)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.userMobil = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('a', {
    staticClass: "manage-save-btn font-color-orange",
    on: {
      "click": _vm.updateAddress
    }
  }, [_vm._v("保存")]), _vm._v(" "), _c('span', {
    staticClass: "manage-modify-btn",
    on: {
      "click": _vm.cancelUpdateAddress
    }
  }, [_vm._v("取消")])])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isModify),
      expression: "!isModify"
    }]
  }, [_c('div', {
    staticClass: "manage-config-info margin-bottom-15"
  }, [_c('div', {
    staticClass: "manage-config-info-title"
  }, [_vm._v("修改密码")]), _vm._v(" "), _c('div', {
    staticClass: "manage-config-info-content"
  }, [_c('div', [_c('label', [_vm._v("原始密码：")]), _vm._v(" "), _c('span', {
    staticClass: "manage-config-info-input modifyPw-input"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.oldPw),
      expression: "oldPw"
    }],
    attrs: {
      "type": "password"
    },
    domProps: {
      "value": (_vm.oldPw)
    },
    on: {
      "focus": _vm.hideTip,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.oldPw = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "modifyPw-tip font-color-green"
  }, [_vm._v("忘记密码请联系客服")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.pwErrorTip),
      expression: "pwErrorTip"
    }],
    staticClass: "modifyPw-error-tip"
  }, [_c('label'), _vm._v(" "), _c('span', {
    staticClass: "font-color-red"
  }, [_vm._v("密码错误")])])]), _vm._v(" "), _c('div', [_c('label', [_vm._v("新密码：")]), _vm._v(" "), _c('span', {
    staticClass: "manage-config-info-input modifyPw-input"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newPw),
      expression: "newPw"
    }],
    attrs: {
      "type": "password"
    },
    domProps: {
      "value": (_vm.newPw)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newPw = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "modifyPw-tip font-color-green"
  }, [_vm._v("注：英文区分大小写")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.newPwTip),
      expression: "newPwTip"
    }],
    staticClass: "modifyPw-error-tip"
  }, [_c('label'), _vm._v(" "), _c('span', {
    staticClass: "font-color-red"
  }, [_vm._v("密码至少6位")])])]), _vm._v(" "), _c('div', [_c('label', [_vm._v("确认新密码：")]), _vm._v(" "), _c('span', {
    staticClass: "manage-config-info-input modifyPw-input"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.confirmNewPw),
      expression: "confirmNewPw"
    }],
    attrs: {
      "type": "password"
    },
    domProps: {
      "value": (_vm.confirmNewPw)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.confirmNewPw = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.confirmErrorTip),
      expression: "confirmErrorTip"
    }],
    staticClass: "modifyPw-error-tip"
  }, [_c('label'), _vm._v(" "), _c('span', {
    staticClass: "font-color-red"
  }, [_vm._v("请与新密码保持一致")])])]), _vm._v(" "), _c('a', {
    staticClass: "manage-save-btn font-color-orange",
    on: {
      "click": _vm.modifyPw
    }
  }, [_vm._v("保存")]), _vm._v(" "), _c('span', {
    staticClass: "manage-modify-btn",
    on: {
      "click": _vm.cancelPwModify
    }
  }, [_vm._v("取消")])])])])]) : _vm._e(), _vm._v(" "), (_vm.selectPage == 2) ? _c('div', [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "address"
  }), _vm._v(" "), _c('div', {
    staticClass: "addressContent",
    staticStyle: {
      "margin-bottom": "20px"
    }
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [(_vm.cascaderData2.length <= 0) ? _c('div', {
    staticClass: "empty_address"
  }, [_c('div'), _vm._v(" "), _c('div', [_vm._v("暂无特别关注区域！")])]) : _c('ul', _vm._l((_vm.cascaderData3), function(item, index) {
    return _c('el-tag', {
      key: index,
      staticClass: "item",
      attrs: {
        "closable": ""
      },
      on: {
        "close": function($event) {
          return _vm.onClickTag(item[2], item[1])
        }
      }
    }, [_vm._v(_vm._s(item[0].split('|')[1] + '/' + item[1].split('|')[1] + '/' + item[2].split('|')[1]))])
  }), 1)])])]) : _vm._e(), _vm._v(" "), (_vm.selectPage == 3) ? _c('div', [_c('div', {
    staticClass: "third_block"
  }, [_vm._m(3), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "radio-setting"
  }, [_c('el-radio', {
    attrs: {
      "label": "0",
      "disabled": _vm.show_save_shop_style
    },
    model: {
      value: (_vm.radioValue),
      callback: function($$v) {
        _vm.radioValue = $$v
      },
      expression: "radioValue"
    }
  }, [_vm._v("带票&不带票全部展示")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "1",
      "disabled": _vm.show_save_shop_style
    },
    model: {
      value: (_vm.radioValue),
      callback: function($$v) {
        _vm.radioValue = $$v
      },
      expression: "radioValue"
    }
  }, [_vm._v("仅展示带票商品")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "2",
      "disabled": _vm.show_save_shop_style
    },
    model: {
      value: (_vm.radioValue),
      callback: function($$v) {
        _vm.radioValue = $$v
      },
      expression: "radioValue"
    }
  }, [_vm._v("仅展示不带票商品")])], 1), _vm._v(" "), (_vm.show_save_shop_style) ? _c('div', {
    staticClass: "update_btn",
    on: {
      "click": function($event) {
        _vm.show_save_shop_style = false
      }
    }
  }, [_vm._v("修改")]) : _c('div', [_c('div', {
    staticClass: "a",
    on: {
      "click": _vm.onSaveRadioValue
    }
  }, [_vm._v("保存")]), _vm._v(" "), _c('div', {
    on: {
      "click": _vm.onRefreshRadioValue
    }
  }, [_vm._v("取消")])])])]), _vm._v(" "), _c('div', {
    staticClass: "third_block",
    staticStyle: {
      "margin-top": "30px"
    }
  }, [_vm._m(4), _vm._v(" "), _c('div', [_c('div', [_c('el-checkbox-group', {
    staticClass: "check-list",
    model: {
      value: (_vm.checkList),
      callback: function($$v) {
        _vm.checkList = $$v
      },
      expression: "checkList"
    }
  }, [_c('el-checkbox', {
    attrs: {
      "label": "一件代发",
      "disabled": _vm.show_save_server_style
    }
  }), _vm._v(" "), _c('el-checkbox', {
    attrs: {
      "label": "社群集采（运费线下另算）",
      "disabled": _vm.show_save_server_style
    }
  })], 1)], 1)])])]) : _vm._e()])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sp2-t1"
  }, [_vm._v("\n          特别关注区域设置\n          "), _c('span', [_vm._v("(如需设置请联系吉贡运营)")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sp2-t2"
  }, [_c('div', [_c('span', {
    staticClass: "infoicon"
  }), _vm._v("温馨提示\n          ")]), _vm._v(" "), _c('div', [_vm._v("如果您对供货的覆盖面有要求，可以设置您的特别关注区域，设置后选货商城将不再提供无法达到您特别关注区域的货品。")]), _vm._v(" "), _c('div', [_c('div', [_vm._v("例如:")]), _vm._v(" "), _c('div', [_c('div', [_vm._v("a.货品必须能供货到新疆，那不到新疆的不会出现在您的视野内；")]), _vm._v(" "), _c('div', [_vm._v("b.货品必须能供货到内蒙，海南，云南，北京，那货物无法达到这几个区域中的任意区域时，该货品都不会展示。")])])]), _vm._v(" "), _c('div', [_vm._v("【注：如果您是做全国范围电商，可以允许部分商品对部分区域不供货。那请不要使用这个功能，系统将不设任何过滤】")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "title"
  }, [_c('div', [_vm._v("已选的特别关注区域")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', [_vm._v("商品展示类型设置")]), _vm._v(" "), _c('div', [_vm._v("请根据您的需要选择商城商品的展示类型，该设置将影响选货商城您看到的商品")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', [_vm._v("服务类型设置")]), _vm._v(" "), _c('div', [_vm._v("如需更改服务类型，请联系吉贡的对接运营。")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0aea40b6","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Center.vue
// module id = 514
// module chunks = 1